import React from 'react';
import {Navigate as navigate} from 'react-big-calendar';

/**
 *
 */
function ViewNamesGroup({views, view, messages, onView}) {
  return (
    <>
      {views.map((name) => (
        <button
          type="button"
          key={name}
          className={view === name ? 'rbc-active' : ''}
          onClick={() => onView(name)}
        >
          {messages[name]}
        </button>
      ))}
    </>
  );
}

const CustomToolbar = ({
  label,
  localizer,
  messages: propMessages,
  onNavigate,
  onView,
  view,
  views,
}) => {
  // ✅ messages可以從localizer來，也可以從props來
  const messages = propMessages ||
    localizer?.messages || {
    month: '月',
    week: '週',
    day: '日',
    today: '今天',
    previous: '上一頁',
    next: '下一頁',
  };

  const handleNavigate = (direction) => {
    onNavigate(direction);
  };

  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        <ViewNamesGroup
          views={views}
          view={view}
          messages={messages}
          onView={onView}
        />
      </span>

      <span className="rbc-toolbar-label">{label}</span>

      <span className="rbc-btn-group examples--custom-toolbar">
        <button
          type="button"
          onClick={() => handleNavigate(navigate.PREVIOUS)}
          aria-label={messages.previous}
        >
          &#60;
        </button>
        <button
          type="button"
          onClick={() => handleNavigate(navigate.TODAY)}
          aria-label={messages.today}
        >
          &#8226;
        </button>
        <button
          type="button"
          onClick={() => handleNavigate(navigate.NEXT)}
          aria-label={messages.next}
        >
          &#62;
        </button>
      </span>
    </div>
  );
};

export default CustomToolbar;
